document.addEventListener('DOMContentLoaded',function(){
  var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return [].slice.call((r||document).querySelectorAll(s))};
  var esc=function(t){return String(t).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})};

  /* Sticky header wrapper (Shopify wraps each section in its own div) */
  var hd=$('.site-header');if(hd&&hd.parentElement)hd.parentElement.classList.add('is-sticky-wrap');

  /* Mobile drawer */
  var dr=$('#Drawer'),mb=$('#MenuBtn');
  if(dr&&mb){
    var setNav=function(o){dr.classList.toggle('open',o);document.documentElement.classList.toggle('nav-open',o);mb.setAttribute('aria-expanded',o);mb.setAttribute('aria-label',o?'Close menu':'Open menu');if(o){var f=$('.drawer-panel a,.drawer-panel button',dr);f&&f.focus()}else if(document.activeElement&&dr.contains(document.activeElement))mb.focus()};
    mb.addEventListener('click',function(){setNav(!dr.classList.contains('open'))});
    dr.addEventListener('click',function(e){if(e.target.closest('[data-close]')||e.target.closest('a.dl'))setNav(false)});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&dr.classList.contains('open'))setNav(false)});
    window.addEventListener('resize',function(){if(window.innerWidth>860&&dr.classList.contains('open'))setNav(false)});
    window.addEventListener('pageshow',function(){setNav(false)});
  }

  /* Halloween countdown */
  $$('[data-halloween]').forEach(function(el){
    var n=new Date(),y=n.getFullYear(),h=new Date(y,9,31,23,59,59);
    if(n>h)h=new Date(y+1,9,31,23,59,59);
    var d=Math.ceil((h-n)/864e5);
    el.textContent=(n.getMonth()===9&&n.getDate()===31)?'Halloween is today':(d===1?'Halloween is tomorrow':d+' days until Halloween');
  });

  /* Size guide tabs */
  function tab(c){$$('.tab').forEach(function(t){t.classList.toggle('on',t.dataset.t===c)});$$('.panel').forEach(function(p){p.classList.toggle('on',p.dataset.p===c)});}
  $$('.tab').forEach(function(t){t.addEventListener('click',function(){tab(t.dataset.t)})});

  /* Gallery */
  var main=$('#MainImg');
  function showThumb(t){if(main&&t.dataset.full)main.src=t.dataset.full;var th=$$('.thumb'),gc=$('#GCount'),bx=t.parentElement;th.forEach(function(x){x.classList.remove('on')});t.classList.add('on');if(gc)gc.textContent=(th.indexOf(t)+1)+' / '+th.length;if(bx&&bx.scrollWidth>bx.clientWidth)bx.scrollTo({left:t.offsetLeft-(bx.clientWidth-t.offsetWidth)/2,behavior:'smooth'});}
  function step(d){var th=$$('.thumb'),i=th.findIndex(function(x){return x.classList.contains('on')}),n=th[(i+d+th.length)%th.length];if(n)showThumb(n)}
  var gp=$('#GPrev'),gn=$('#GNext');if(gp&&gn){if($$('.thumb').length<2){gp.hidden=gn.hidden=true}else{gp.addEventListener('click',function(){step(-1)});gn.addEventListener('click',function(){step(1)})}}
  var t0=$('.thumb.on');if(t0)showThumb(t0);
  $$('details.acc').forEach(function(d){d.open=window.innerWidth>860});
  $$('.thumb').forEach(function(t){t.addEventListener('click',function(){showThumb(t)})});
  var mi=$('.main-img'),sx=0,sy=0;
  if(mi){mi.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY},{passive:true});
    mi.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;if(Math.abs(dx)<50||Math.abs(dx)<Math.abs(dy)*1.5)return;
      var th=$$('.thumb'),i=th.findIndex(function(x){return x.classList.contains('on')}),n=th[i+(dx<0?1:-1)];
      if(n)showThumb(n)},{passive:true})}

  /* Bundle builder */
  var cfgEl=$('#BundleCfg');if(!cfgEl)return;
  var cfg=JSON.parse(cfgEl.textContent),robesEl=$('#Robes'),err=$('#Err'),add=$('#AddBundle');
  var fmt=function(c){try{return new Intl.NumberFormat(document.documentElement.lang||undefined,{style:'currency',currency:cfg.cur}).format(c/100)}catch(e){return (c/100).toFixed(2)}};
  var state=[0,1,2].map(function(i){return {c:cfg.chars[i]||cfg.chars[0],s:''}});
  var pc=new URLSearchParams(location.search).get('character');if(pc&&cfg.chars.indexOf(pc)>-1)state[0].c=pc;
  var qty=function(){return +$('input[name=bundle]:checked').value};
  var sizesFor=function(c){return cfg.sizes.filter(function(s){return cfg.map[c+'|'+s]})};
  var ok=function(c,s){var v=cfg.map[c+'|'+s];return v&&v.ok};
  function thumbFor(c){var t=$('.thumb[data-char="'+c+'"]');if(t)showThumb(t)}

  function totals(){
    var q=qty(),base=0;
    for(var i=0;i<q;i++){var v=cfg.map[state[i].c+'|'+state[i].s];base+=v?v.price:cfg.unit}
    var pct=cfg.pct[q]||0,fin=Math.round(base*(1-pct/100));
    $('#PriceNow').textContent=fmt(fin);$('#AtcPrice').textContent=fmt(fin);$('#StPrice').textContent=fmt(fin);
    var was=$('#PriceWas'),sv=$('#SaveBadge');
    if(pct){was.textContent=fmt(base);was.hidden=false;sv.textContent='Save '+pct+'%';sv.hidden=false}else{was.hidden=true;sv.hidden=true}
    [1,2,3].forEach(function(n){var b=cfg.unit*n,p=cfg.pct[n]||0,f=Math.round(b*(1-p/100));
      $('[data-bp="'+n+'"]').innerHTML=(p?'<s>'+fmt(b)+'</s>':'')+fmt(f);$('[data-be="'+n+'"]').textContent=fmt(Math.round(f/n))+' each';});
  }
  function render(){
    var q=qty(),h='';
    for(var i=0;i<q;i++){var r=state[i];
      h+='<div class="robe" data-i="'+i+'"><div class="robe-h">Robe '+(i+1)+'</div><div class="sw">';
      cfg.chars.forEach(function(c){h+='<button type="button" class="swb'+(r.c===c?' on':'')+'" data-c="'+esc(c)+'" aria-pressed="'+(r.c===c)+'">'+(cfg.sw[c]?'<img src="'+cfg.sw[c]+'" alt="">':'')+'<span>'+esc(c)+'</span></button>'});
      h+='</div><div class="szs">';
      sizesFor(r.c).forEach(function(s){h+='<button type="button" class="szb'+(r.s===s?' on':'')+'" data-s="'+esc(s)+'"'+(ok(r.c,s)?'':' disabled')+'>'+esc(s)+'</button>'});
      h+='</div></div>';}
    robesEl.innerHTML=h;$$('.bcard').forEach(function(l){l.classList.toggle('sel',l.querySelector('input').checked)});totals();
  }
  robesEl.addEventListener('click',function(e){
    var row=e.target.closest('.robe');if(!row)return;var i=+row.dataset.i,b;
    if((b=e.target.closest('.swb'))){state[i].c=b.dataset.c;if(sizesFor(state[i].c).indexOf(state[i].s)<0)state[i].s='';if(i===0)thumbFor(state[i].c);render();}
    else if((b=e.target.closest('.szb'))&&!b.disabled){state[i].s=b.dataset.s;err.hidden=true;render();}
  });
  $$('input[name=bundle]').forEach(function(r){r.addEventListener('change',render)});
  var fs=$('#FindSize');if(fs)fs.addEventListener('click',function(){tab(state[0].c)});
  render();thumbFor(state[0].c);

  add.addEventListener('click',function(){
    err.hidden=true;var q=qty(),items={};
    for(var i=0;i<q;i++){var r=state[i];
      if(!r.s){err.textContent='Pick a size for robe '+(i+1)+'. Measure the neck first, or open the size guide.';err.hidden=false;robesEl.scrollIntoView({behavior:'smooth',block:'center'});return}
      var v=cfg.map[r.c+'|'+r.s];if(!v||!v.ok){err.textContent='Sorry, '+r.c+' / '+r.s+' is unavailable.';err.hidden=false;return}
      items[v.id]=(items[v.id]||0)+1}
    var list=Object.keys(items).map(function(id){return {id:+id,quantity:items[id]}});
    var pr=$('#Prot');if(pr&&pr.checked)list.push({id:+pr.value,quantity:1});
    add.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:list})})
      .then(function(r){if(!r.ok)throw 0;window.location.href='/cart'})
      .catch(function(){err.textContent='Could not add to cart. Please try again.';err.hidden=false;add.disabled=false});
  });

  /* Sticky add-to-cart bar */
  var sb=$('#Sticky'),sbtn=$('#StBtn');
  if(sb&&'IntersectionObserver' in window){
    new IntersectionObserver(function(e){sb.classList.toggle('show',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)}).observe(add);
    sbtn.addEventListener('click',function(){add.click()});
  }
});
